import React, { useState, useEffect, useRef } from "react";
import "./Navbar.css";

import black from "../../Photos/Logos/LogoBK.png";
import blue from "../../Photos/Logos/LogoB.png";
import purple from "../../Photos/Logos/LogoP.png";
import white from "../../Photos/Logos/LogoW.png";

function Navbar({ darkMode, toggleDarkMode }) {
    const [hover, setHover] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);

    const navRef = useRef(null);

    const lightLogo = hover ? blue : black;
    const darkLogo = hover ? white : purple;
    const logoState = darkMode ? darkLogo : lightLogo;

    // Close menu when clicking outside navbar
    useEffect(() => {
        function handleClickOutside(event) {
            if (navRef.current && !navRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Close menu on nav link click
    function handleLinkClick() {
        setShowDropdown(false);
    }

    return (
        <nav ref={navRef} className={`navbar ${darkMode ? "dark" : ""}`}>
            <a
                href="/"
                className="logo-wrapper"
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
            >
                <img src={logoState} alt="OA Logo" className="logo" />
            </a>

            <div
                className={`menu-icon ${showDropdown ? "active" : ""}`}
                onClick={() => setShowDropdown((prev) => !prev)}
            >
                ☰
            </div>

            <ul className={`nav-links ${showDropdown ? "active" : ""}`}>
                <li>
                    <a href="#home" onClick={handleLinkClick}>
                        Home
                    </a>
                </li>
                <li>
                    <a href="#about" onClick={handleLinkClick}>
                        About
                    </a>
                </li>
                <li>
                    <a href="#skill" onClick={handleLinkClick}>
                        Skills
                    </a>
                </li>
                <li>
                    <a href="#experience" onClick={handleLinkClick}>
                        Experience
                    </a>
                </li>
                <li>
                    <a href="#project" onClick={handleLinkClick}>
                        Projects
                    </a>
                </li>
                <li>
                    <a href="#contact" onClick={handleLinkClick}>
                        Contact
                    </a>
                </li>
            </ul>

            <button
                className="theme-toggle"
                onClick={toggleDarkMode}
                aria-label="Toggle dark mode"
            >
                {darkMode ? "☀" : "☾"}
            </button>
        </nav>
    );
}

export default Navbar;
